// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2DBtA","large":"styles_large__27gDv"};